






























import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      isShowMore: false,
    }
  },

  props: {
    title: {
      type: String,
    },
    image: {
      type: [String, Number],
    },
    text: {
      type: String,
    },
  },
});
